export enum VotePositioningEnum {
  'against' = 'Contra',
  'infavor' = 'A Favor',
  'other' = 'Outro',
}

export type VotePositioningKeys = keyof typeof VotePositioningEnum
